export var FUNDING_LOG_NEW_WINDOW_MS = 5 * 60 * 1000;
export var EMPTY_FUNDING_LOG_NEW_TRACKING = { rows: {}, bumps: {} };
var storageKeyFor = function (accountId) {
    return "fundingLog.newTracking.v1.".concat(accountId !== null && accountId !== void 0 ? accountId : 'anonymous');
};
var isFresh = function (at, now) { return now - at < FUNDING_LOG_NEW_WINDOW_MS; };
export var pruneFundingLogNewTracking = function (state, now) {
    if (now === void 0) { now = Date.now(); }
    var rows = {};
    Object.entries(state.rows).forEach(function (_a) {
        var queue = _a[0], ids = _a[1];
        var kept = Object.fromEntries(Object.entries(ids).filter(function (_a) {
            var at = _a[1];
            return isFresh(at, now);
        }));
        if (Object.keys(kept).length > 0)
            rows[queue] = kept;
    });
    var bumps = {};
    Object.entries(state.bumps).forEach(function (_a) {
        var queue = _a[0], list = _a[1];
        var kept = list.filter(function (bump) { return isFresh(bump.at, now); });
        if (kept.length > 0)
            bumps[queue] = kept;
    });
    return { rows: rows, bumps: bumps };
};
export var loadFundingLogNewTracking = function (accountId) {
    var _a, _b;
    try {
        var raw = window.localStorage.getItem(storageKeyFor(accountId));
        if (!raw)
            return EMPTY_FUNDING_LOG_NEW_TRACKING;
        var parsed = JSON.parse(raw);
        return pruneFundingLogNewTracking({ rows: (_a = parsed === null || parsed === void 0 ? void 0 : parsed.rows) !== null && _a !== void 0 ? _a : {}, bumps: (_b = parsed === null || parsed === void 0 ? void 0 : parsed.bumps) !== null && _b !== void 0 ? _b : {} });
    }
    catch (_c) {
        return EMPTY_FUNDING_LOG_NEW_TRACKING;
    }
};
export var saveFundingLogNewTracking = function (accountId, state) {
    try {
        window.localStorage.setItem(storageKeyFor(accountId), JSON.stringify(state));
    }
    catch (_a) {
    }
};
export var getNewRowIds = function (state, queue, now) {
    var _a;
    if (now === void 0) { now = Date.now(); }
    return new Set(Object.entries((_a = state.rows[queue]) !== null && _a !== void 0 ? _a : {}).filter(function (_a) {
        var at = _a[1];
        return isFresh(at, now);
    }).map(function (_a) {
        var id = _a[0];
        return id;
    }));
};
export var getNewCounts = function (state, now) {
    if (now === void 0) { now = Date.now(); }
    var counts = {};
    Object.entries(state.bumps).forEach(function (_a) {
        var queue = _a[0], list = _a[1];
        var total = list.filter(function (bump) { return isFresh(bump.at, now); }).reduce(function (sum, bump) { return sum + bump.delta; }, 0);
        if (total > 0)
            counts[queue] = total;
    });
    return counts;
};
export var getNextExpiry = function (state) {
    var times = [];
    Object.values(state.rows).forEach(function (ids) { return Object.values(ids).forEach(function (at) { return times.push(at); }); });
    Object.values(state.bumps).forEach(function (list) { return list.forEach(function (bump) { return times.push(bump.at); }); });
    return times.length > 0 ? Math.min.apply(Math, times) + FUNDING_LOG_NEW_WINDOW_MS : undefined;
};
